export const MLA_ATTRIBUTE_EDIT_OPTION_LABEL = 'Edit Attribute';
